import { createContext, useContext } from 'react';
import { ShapeTypes } from '@diagram/model/node.model';

export type DnDContextDataType =
  | {
      type: 'shape';
      shape: ShapeTypes;
      width: number;
      height: number;
    }
  | {
      type: 'swimlane';
      orientation: 'horizontal' | 'vertical';
      width: number;
      height: number;
    };

export const DnDContext = createContext<{
  data: DnDContextDataType;
  setData: React.Dispatch<React.SetStateAction<DnDContextDataType>>;
}>({
  data: {
    type: 'shape',
    shape: 'square',
    width: 100,
    height: 100,
  },
  setData: () => {},
});

export const useDnD = () => {
  return useContext(DnDContext);
};
